import LazyLoadManager from "./lazyload";

export function loadMoreArticles() {
  // console.log("loadMoreArticles function loaded."); // Verifica che la funzione venga caricata
  jQuery(".otherarticle").click(function () {
    // console.log("Button clicked."); // Verifica che il click venga rilevato

    var lang = $(this).data("lang");
    var slug = $(this).data("slug");
    var from = $("#block_").find(".tile").length;
    var tile = $(this).data("tile");
    var tileclass = $(this).data("tileclass");
    var filterid = $(this).data("tagid");
    var taxid = $(this).data("id");

    // console.log(
//      "Data extracted:",
//      lang,
//      slug,
//      from,
//      tile,
//      tileclass,
//      filterid,
//      taxid
//    ); // Mostra i dati estratti

    if (filterid.length > 0) {
      taxonomiesIds = taxid;
      if (filterid.length > 0) {
        taxonomiesIds = taxid + "," + filterid;
      }
      // console.log("Taxonomies IDs:Pippo", taxonomiesIds); // Mostra gli ID delle tassonomie
      $.ajax({
        type: "POST",
        dataType: "html",
        url: "/mosaic/" + lang + "/" + slug + "/" + from,
        context: this,
        data: {
          afilter: { taxonomiesall: taxonomiesIds },
          tile: tile,
          tileclass: tileclass,
        },
        success: function (j) {
          // console.log("AJAX request successful."); // Successo della richiesta AJAX
          if (j.length !== 0) {
            // console.log("Appending content."); // Contenuto in fase di aggiunta
            $("#b_" + slug).append(j);
            if (lazyLoadInstance) {
              lazyLoadInstance.update();
            } else {
              var htmlEntity =
                document.getElementsByClassName("mosaicWrapper")[0];

              var lazyLoadInstance = new LazyLoadManager({
                container: htmlEntity,
                elements_selector: ".lazy",
              });
              // console.log("LazyLoad instance created."); // Istanza LazyLoad creata
            }
          } else {
            $(".otherarticle").fadeOut();
            // console.log("No content to append, fading out button."); // Nessun contenuto da aggiungere, nasconde il pulsante
          }
        },
        error: function (j) {
          // console.log("AJAX request failed:", j); // Fallimento della richiesta AJAX
        },
      });
    } else {
      $.ajax({
        type: "POST",
        dataType: "html",
        url: "/mosaic/" + lang + "/" + slug + "/" + from,
        context: this,
        data: { tile: tile, tileclass: tileclass },
        success: function (j) {
          // console.log("AJAX request (no filter) successful."); // Successo della richiesta AJAX (senza filtro)
          if (j.length !== 0) {
            // console.log("Appending content (no filter)."); // Contenuto in fase di aggiunta (senza filtro)
            $("#block_").append(j);
            if (lazyLoadInstance) {
              lazyLoadInstance.update();
            } else {
              var htmlEntity =
                document.getElementsByClassName("contentlist")[0];
              // console.log(htmlEntity);
              var lazyLoadInstance = new LazyLoadManager({
                container: htmlEntity,
                elements_selector: ".lazy",
              });
              // console.log("LazyLoad instance (no filter) created."); // Istanza LazyLoad creata (senza filtro)
            }
          } else {
            $(".otherarticle").fadeOut();
            // console.log("No content to append (no filter), fading out button."); // Nessun contenuto da aggiungere (senza filtro), nasconde il pulsante
          }
        },
        error: function (j) {
          // console.log("AJAX request (no filter) failed:", j); // Fallimento della richiesta AJAX (senza filtro)
        },
      });
    }
  });
}
